import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./App.css";
import Layout from "./components/Layout";
import Home from "./pages/Home";
import Tutors from "./pages/Tutors";
import Team from "./pages/Team";
import Bookings from "./pages/Bookings";
import Apply from './pages/Apply';
import { ThemeProvider } from "./contexts/ThemeContext";
import AdminPage from './pages/AdminPage';
import BookingsForm from './pages/BookingsForm';
import ContactUs from './pages/ContactUs';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <ThemeProvider>
      <Router>
        <ScrollToTop />
        <Routes>
          <Route 
            path="/" 
            element={<Layout currentPageName="Home"><Home /></Layout>} 
          />
          <Route 
            path="/tutors" 
            element={<Layout currentPageName="Tutors"><Tutors /></Layout>} 
          />
          <Route 
            path="/team" 
            element={<Layout currentPageName="Team"><Team /></Layout>} 
          />
          <Route 
            path="/bookings" 
            element={<Layout currentPageName="Bookings"><Bookings /></Layout>} 
          />
          <Route 
            path="/apply" 
            element={<Layout currentPageName="Apply For Tutoring"><Apply /></Layout>} 
          />
          <Route 
            path="/admin" 
            element={<AdminPage />} 
          />
          <Route 
            path="/bookingsform" 
            element={<BookingsForm />} 
          />
          <Route 
            path="/contactus" 
            element={<ContactUs />} 
          />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;